import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["listing", "onOk"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DixuForm from "../DixuForm/DixuForm";
import DixuInput from "../DixuInput/DixuInput";
import DixuModal from "../DixuModal/DixuModal";
import DixuNotification from "../DixuNotification/DixuNotification";
import DixuRealtorInfo from "../DixuRealtorInfo/DixuRealtorInfo";
import DixuText from "../DixuText/DixuText";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import React from 'react';
import { getErrorDescription, sendNewListingMessage } from "../../services/ApiService";
import { SERVICE_PACKAGE } from "../../utils/DixuConstants";
import { isRealtorListing } from "../../utils/DixuListingUtils";
const DixuContactSellerModal = _ref => {
  let {
      listing,
      onOk
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [form] = DixuForm.useForm();
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    id,
    realtor,
    servicePackage
  } = listing || {};
  const realtorSelling = isRealtorListing(listing);
  const title = realtorSelling ? t('listing:MessageForm.TitleRealtor') : t('listing:MessageForm.Title');
  const info = realtorSelling ? t('listing:MessageForm.DetailsSentToRealtorAutomatically') : t('listing:MessageForm.DetailsSentToSellerAutomatically');
  const [submitForm, isSubmittingForm] = useIsLoading(async values => {
    try {
      await sendNewListingMessage({
        listingID: id,
        data: values
      });
      form.resetFields();
      DixuNotification.open({
        message: servicePackage === SERVICE_PACKAGE.DIXU_EASY ? t('listing:MessageForm:MessageSent') : t('listing:MessageForm:MessageSentRealtor')
      });
      form.resetFields();
      onOk?.();
    } catch (error) {
      DixuNotification.error({
        message: 'Viestin lähettäminen epäonnistui',
        description: getErrorDescription(error)
      });
    }
  });
  return /*#__PURE__*/React.createElement(DixuModal, _objectSpread(_objectSpread({}, rest), {}, {
    title,
    width: realtorSelling ? 582 : 374,
    loading: isSubmittingForm,
    okText: t('common:Send'),
    onOk: null,
    okButtonProps: {
      htmlType: 'submit',
      form: 'contact-seller'
    }
  }), /*#__PURE__*/React.createElement(DixuForm, {
    form: form,
    name: "contact-seller",
    onFinish: submitForm
  }, realtorSelling && /*#__PURE__*/React.createElement(DixuRealtorInfo, {
    realtor: realtor,
    listing: listing
  }), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "message",
    label: t('listing:MessageForm.YourMessage'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput.TextArea, {
    autoSize: {
      minRows: 8
    }
  })), /*#__PURE__*/React.createElement(DixuText, {
    size: "2",
    color: "2-9",
    block: true
  }, info)));
};
export default DixuContactSellerModal;